/*eslint-disable*/
import{ Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { Line, Bar } from "react-chartjs-2";
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";


import React from "react";

class Graph extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          graphLabels: ["0"],
          graphData: [0],
          store:{},
          max:1,
          min:0,
        };
        this.chart_options = {
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          tooltips: {
            backgroundColor: "#f5f5f5",
            titleFontColor: "#333",
            bodyFontColor: "#666",
            bodySpacing: 4,
            xPadding: 12,
            mode: "nearest",
            intersect: 0,
            position: "nearest"
          },
          responsive: true,
          scales: {
            yAxes: [
              {
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: "rgba(29,140,248,0.0)",
                  zeroLineColor: "transparent"
                },
                ticks: {
                  suggestedMin: this.state.min,
                  suggestedMax: this.state.max,
                  padding: 20,
                  fontColor: "#9a9a9a"
                }
              }
            ],
            xAxes: [
              {
                barPercentage: 1.6,
                gridLines: {
                  drawBorder: false,
                  color: "rgba(29,140,248,0.1)",
                  zeroLineColor: "transparent"
                },
                ticks: {
                  padding: 20,
                  fontColor: "#9a9a9a"
                }
              }
            ]
          }
        };

        this.example1Data = {
          data: canvas => {
            let ctx = canvas.getContext("2d");

            let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

            gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
            gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
            gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

            return {
              labels: this.state.graphLabels,
              datasets: [
                {
                  label: "Data",
                  fill: false,
                  backgroundColor: gradientStroke,
                  borderColor: "#71b16d",
                  borderWidth: 2,
                  borderDash: [],
                  borderDashOffset: 0.0,
                  pointBackgroundColor: "#71b16d",
                  pointBorderColor: "rgba(255,255,255,0)",
                  pointHoverBackgroundColor: "#71b16d",
                  pointBorderWidth: 20,
                  pointHoverRadius: 4,
                  pointHoverBorderWidth: 15,
                  pointRadius: 4,
                  data: this.state.graphData
                }
              ]
            };
          },
          options: this.chart_options
        };
    }

    componentDidMount(){
      this.setGraphsSensor(this.props.variable);
    }

    setGraphsSensor(sensor){
      switch(sensor) {
        case 'AmbientHumidity':
          console.log("SET - AmbientHumidity");
          this.setState({
            key: this.props.store.AmbientHumiditySensor.key,
            graphLabels: this.props.store.AmbientHumiditySensor.labels,
            graphData: this.props.store.AmbientHumiditySensor.values,
            max:85,
            min:0,
          })
          break;
        case 'UV':
          console.log("SET - UV");
          this.setState({
            key: this.props.store.UVSensor.key,
            graphLabels: this.props.store.UVSensor.labels,
            graphData: this.props.store.UVSensor.values
          })
          break;
        case 'AmbientTemp':
          console.log("SET - AmbientTemp");
          this.setState({
            key: this.props.store.AmbientTempSensor.key,
            graphLabels: this.props.store.AmbientTempSensor.labels,
            graphData: this.props.store.AmbientTempSensor.values,
            max:25,
            min:5,
          })
          break;
        case 'BarometerMoisture':
          console.log("SET - BarometerMoisture");
          this.setState({
            key: this.props.store.BarometerMoistureSensor.key,
            graphLabels: this.props.store.BarometerMoistureSensor.labels,
            graphData: this.props.store.BarometerMoistureSensor.values
          })
          break;
        case 'SoilTemp':
          console.log("SET - SoilTemp");
          this.setState({
            key: this.props.store.SoilTempSensor.key,
            graphLabels: this.props.store.SoilTempSensor.labels,
            graphData: this.props.store.SoilTempSensor.values
          })
          break;
        case 'SoilMoisture':
          console.log("SET - SoilMoisture");
          this.setState({
            key: this.props.store.SoilMoistureSensor.key,
            graphLabels: this.props.store.SoilMoistureSensor.labels,
            graphData: this.props.store.SoilMoistureSensor.values,
            min:0,
            max:100,
          })
          break;
        case 'BarometerTemp':
          console.log("SET - BarometerTemp");
          this.setState({
            key: this.props.store.BarometerTempSensor.key,
            graphLabels: this.props.store.BarometerTempSensor.labels,
            graphData: this.props.store.BarometerTempSensor.values
          })
          break;
        case 'WindSpeed':
          console.log("SET - WindSpeed");
          this.setState({
            key: this.props.store.WindSpeedSensor.key,
            graphLabels: this.props.store.WindSpeedSensor.labels,
            graphData: this.props.store.WindSpeedSensor.values,
            max:20,
            min:0,
          })
          break;
        case 'BarometerPressure':
          console.log("SET - BarometerPressure");
          this.setState({
            key: this.props.store.BarometerPressureSensor.key,
            graphLabels: this.props.store.BarometerPressureSensor.labels,
            graphData: this.props.store.BarometerPressureSensor.values
          })
          break;
        default:
          console.log("ERROR");
          break;
      }
    }

    componentDidUpdate(prevProps) {
      // Typical usage (don't forget to compare props):
      if (this.props.store.timestamp !== prevProps.store.timestamp) {
        this.setGraphsSensor(this.props.variable);
      }
      else if (this.props.variable !== prevProps.variable) {
        this.setGraphsSensor(this.props.variable);
      }
      else if (this.props.num !== prevProps.num) {
        console.log("here");
        this.setGraphsSensor(this.props.variable);
      }
    }

    render() {
      return(
        <>
        <Card className="card-chart">
          <CardHeader>
            <CardTitle tag="h3">
              <h3><i className="tim-icons icon-pin text-AgriBoostGreen" />{" "}
              {this.state.key}</h3>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <div className="chart-area">
              <Line
                data={this.example1Data.data}
                options={this.example1Data.options}
                redraw={this.props.reload}
              />
            </div>
          </CardBody>
        </Card>
        </>
      );
    }
}
export default Graph

// Set default props
Graph.defaultProps = {
  reload: true,
};
